import { useEffect, useState } from "react";
import { useGetCalendarWadgeAgendaMutation } from "./calendarWidgetSlice";
import SmallAppLoader from "../../../components/atoms/app-loader/smallAppLoader";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import CalendarAgenda from "./calendarAgenda";
const CalendarAgendaCard = () => {
  const [getAgendaDetails] = useGetCalendarWadgeAgendaMutation();
  const clickedDate = new Date();
  const [mapAgendaData, setMapAgendaData] = useState<any[]>([]);
  const [todayAgendaLoading, setTodayAgendaLoading] = useState<boolean>(true);
  const user = useSelector((state: RootState) => state.UserInfoSlice);
  useEffect(() => {
    const agendaData = async (url: string) => {
      const payload = {
        searchCriteria: {
          startDate: moment(clickedDate, "DD-MM-YYYY")
            .tz(user.profile.preferences.timezone || "UTC")
            .format("YYYY-MM-DDT00:00:00.000000Z"),
          endDate: moment(clickedDate, "DD-MM-YYYY")
            .tz(user.profile.preferences.timezone || "UTC")
            .format("YYYY-MM-DDT23:59:59.000000Z")
        },
        sortCriteria: {
          sortKey: "startDate",
          order: "DESC",
          pageNo: 0,
          pageCount: 100
        }
      };
      const requestPayload = {
        body: payload,
        uuid: user.profile.id,
        url: url
      };
      await getAgendaDetails(requestPayload)
        .unwrap()
        .then((agendaDataList: any) => {
          let initialMap = agendaDataList?.data?.agendas;
          requestPayload.url = "search/agendas?type=speaker";
          getAgendaDetails(requestPayload)
            .unwrap()
            .then((speakerAgendaDataList: any) => {
              const speakerData = speakerAgendaDataList?.data?.agendas;
              initialMap = [...initialMap, ...speakerData];
              const sortSpeakers = [...initialMap]?.sort((a, b) => {
                const valueA = a.startDate;
                const valueB = b.startDate;
                if (valueA < valueB) {
                  return -1;
                }
                if (valueA > valueB) {
                  return 1;
                }
                return 0;
              });
              setMapAgendaData(sortSpeakers);
              setTodayAgendaLoading(false);
            })
            .catch((error) => {
              setTodayAgendaLoading(false);
            });
        })
        .catch((error) => {
          setTodayAgendaLoading(false);
        });
    };
    agendaData("search/agendas?type=learner");
  }, []);

  return (
    <div className="py-8 px-4 flex flex-col gap-2 w-full">
      <div className="text-lg font-semibold text-secondary px-4 mb-3">
        Agenda For Today
      </div>
      {mapAgendaData.length > 0 ? (
        <div className="flex flex-col px-2 gap-3 max-h-[320px] overflow-y-auto">
          {mapAgendaData.map((agenda: any) => {
            return <CalendarAgenda agenda={agenda} />;
          })}
        </div>
      ) : (
        <>
          {!todayAgendaLoading && (
            <div className="h-24 flex items-center justify-center w-full">
              <span className="text-body text-base font-semibold">
                No agenda for today
              </span>
            </div>
          )}
        </>
      )}
      {todayAgendaLoading && (
        <div className="w-full flex flex-col gap-1 items-center justify-center h-24">
          <SmallAppLoader widthClassName="w-6" heightClassName="h-6" />
          <div className="italic font-medium text-base">Loading Agenda...</div>
        </div>
      )}
    </div>
  );
};

export default CalendarAgendaCard;
